import { ModelHelper } from '../classes/model-helper';

/**
 * Session model
 */
export class Session {
	uid: string;
	user: {
		uid: string;
		username: string;
		firstName: string;
		lastName: string;
	};
	accessToken: string;
	refreshToken: string;
	expirationDate: Date;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Session
	 */
	static map(data: any, item: Session = new Session()): Session {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Session
	 */
	public map(data: any): Session {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'user');
		ModelHelper.map(data, this, 'accessToken');
		ModelHelper.map(data, this, 'refreshToken');
		ModelHelper.map(data, this, 'expirationDate', Date);

		return this;
	}
}
